module.exports = __webpack_public_path__ + "assets/img/lowPriority.6294e1eb.svg";